import { diffInDays } from 'lib/datetime/dateUtils'

/**
 * Computes the number of car hire rental days between pick-up and drop-off.
 * Returns 0 when either date is missing, and clamps to at least 1 day otherwise
 * (a same-day pick-up and drop-off still counts as one rental day).
 */
export function getCarHireRentalDays(pickUpDate?: string | null, dropOffDate?: string | null): number {
  if (!pickUpDate || !dropOffDate) {
    return 0
  }
  const rentalDays = diffInDays(new Date(pickUpDate), new Date(dropOffDate))
  return rentalDays <= 0 ? 1 : rentalDays
}
